import {
  Component, EventEmitter,
  forwardRef,
  Input, OnChanges,
  OnInit, Output, ViewChild,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IDropdownItem } from '@cakeiteasy/web-utils';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'ui-dropdown',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UiDropdownComponent),
      multi: true,
    },
  ],
  template: `
    <div class="dropdown-container dropdown-item-slim">
      <div ngbDropdown #uiDropdown="ngbDropdown"
           [placement]="placement">
        <button type="button" ngbDropdownToggle
                class="btn btn-select fw-normal"
                [disabled]="disabled">
          {{ label || placeholder }}
        </button>

        <div class="dropdown-menu" ngbDropdownMenu>
          <button class="dropdown-item fw-normal"
                  *ngFor="let item of items"
                  [class.selected]="value === item.id"
                  (click)="selectItem(item)">
            {{ item.label }}
          </button>
        </div>
      </div>
    </div>
  `
})
export class UiDropdownComponent implements ControlValueAccessor, OnChanges {
  @Input() items: IDropdownItem[] = [];
  @Input() placeholder = '';
  @Input() placement: string;

  @Output() changeItem = new EventEmitter<IDropdownItem>();
  @ViewChild('uiDropdown', { static: false }) uiDropdown: NgbDropdown;

  value: string | number | null = null;
  disabled = false;
  label = '';

  constructor() {
  }

  ngOnChanges() {
    if (this.items) {
      this.label = this.getLabel();
    }
  }

  open() {
    try {
      this.uiDropdown.open();
    } catch (e) {
      console.error('DROP_DOWN_ERROR', e);
    }
  }

  selectItem(item: IDropdownItem) {
    this.value = item.id;
    this.label = item.label;
    this.onChange(item.id);
    this.onTouched();
    this.changeItem.emit(item);
  }

  writeValue(id: string | number): void {
    this.value = id;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  private getLabel() {
    const item = this.items.find(({ id }) => id === this.value);

    if (item) {
      return item.label;
    }

    return '';
  }

  private onChange = (_: any) => {
  };
  private onTouched = () => {
  };

}
